import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '@shared/lib/cn';

import {
  TOOLTIP_ARROW,
  TOOLTIP_BUBBLE_CLASS,
  TOOLTIP_CONTENT_CLASS,
  TOOLTIP_LAYOUT_CLASS,
  type TooltipPlacement,
  type TooltipTone,
} from './tooltip.constant';

export interface TooltipBubbleProps extends Omit<HTMLAttributes<HTMLDivElement>, 'content'> {
  tone: TooltipTone;
  placement: TooltipPlacement;
  content: ReactNode;
}

/** 말풍선 모양만(위치 · 열림은 `Tooltip` 이 맡는다) */
export function TooltipBubble({
  tone,
  placement,
  content,
  className,
  ...rest
}: TooltipBubbleProps) {
  const arrow = TOOLTIP_ARROW[placement];
  return (
    <div
      role="tooltip"
      data-tone={tone}
      data-placement={placement}
      {...rest}
      className={cn('flex w-max items-center', TOOLTIP_LAYOUT_CLASS[placement], className)}
    >
      <div className={cn('px-2 py-1 typo-caption', TOOLTIP_BUBBLE_CLASS[tone])}>
        <div className={TOOLTIP_CONTENT_CLASS}>{content}</div>
      </div>
      {tone === 'dark' ? (
        <svg
          aria-hidden="true"
          focusable="false"
          width={arrow.width}
          height={arrow.height}
          viewBox={`0 0 ${arrow.width} ${arrow.height}`}
          className="shrink-0 fill-bg-inverse"
        >
          <polygon points={arrow.points} />
        </svg>
      ) : null}
    </div>
  );
}
